module.exports = __webpack_public_path__ + "static/media/online1.01535edd.svg";